document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted === false && !window.location.hash) {
      setTimeout(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, 0);
    }
  });

  const state = {
    allData: JSON.parse(document.getElementById('hoseBuilderData').textContent),
    loadedFittings: {},
    pressureTestPriceInPennies: parseInt(document.getElementById('hose-builder-pressure-test-price')?.dataset.price) || 500,
    selection: {
      collectionHandle: null,
      hoseHandle: null,
      boreVariantId: null,
      length: null,
      fitting1VariantId: null,
      fitting2VariantId: null,
      pressureTest: null, // 'yes' or 'no'
    },
  };

  const view = {
    steps: { step1: document.getElementById('step-1'), step2: document.getElementById('step-2'), step3: document.getElementById('step-3'), step4: document.getElementById('step-4'), step5: document.getElementById('step-5'), step6: document.getElementById('step-6'), step7: document.getElementById('step-7') },
    containers: { collection: document.getElementById('collection-container'), hose: document.getElementById('hose-container'), bore: document.getElementById('bore-container'), length: document.getElementById('length-container'), fitting1: document.getElementById('fitting1-container'), fitting2: document.getElementById('fitting2-container'), pressureTest: document.getElementById('pressure-test-container') },
    summary: { container: document.getElementById('builder-summary'), details: document.getElementById('summary-details'), price: document.getElementById('summary-total-price'), quantityInput: document.getElementById('summary-quantity-input'), button: document.getElementById('summary-add-to-cart-button'), floatingBar: document.getElementById('floating-summary-bar'), floatingPrice: document.getElementById('floating-summary-price'), floatingButton: document.getElementById('floating-summary-button'), cartOverlay: document.getElementById('cart-overlay') },
    modals: {
      info: document.getElementById('info-modal'),
      infoContent: document.getElementById('info-modal-content'),
      guide: document.getElementById('hb-guide-modal')
    },

    renderSummary: () => {
      const { hose, bore, length, fitting1, fitting2, pressureTest, hoseSubtotalInPennies, totalPriceInPennies } = controller.getSummaryData();
      const quantity = parseInt(view.summary.quantityInput.value) || 1;
      
      const createItem = (label, value) => `<div class="summary-item"><strong class="summary-item__label">${label}</strong><span class="summary-item__value">${value}</span></div>`;
      
      const hoseTitle = hose ? hose.title : '-';
      const boreTitle = bore ? bore.title : '-';
      const lengthText = length ? `${length.toFixed(2)}m` : '-';
      
      let fitting1HTML = '';
      if (fitting1) {
        const fitting1Text = `${fitting1.parent.title} <!-- (<span class="summary-item__price">+£${(fitting1.price / 100).toFixed(2)}</span>) -->`;
        fitting1HTML = createItem('Hose End Fitting 1', fitting1Text);
      }
      
      let fitting2HTML = '';
      if (fitting2) {
        const fitting2Text = `${fitting2.parent.title} <!-- (<span class="summary-item__price">+£${(fitting2.price / 100).toFixed(2)}</span>) -->`;
        fitting2HTML = createItem('Hose End Fitting 2', fitting2Text);
      }
      
      let pressureTestHTML = '';
      if (pressureTest === 'yes') {
        const pressureTestText = `Yes (<span class="summary-item__price">+£${(state.pressureTestPriceInPennies / 100).toFixed(2)}</span>)`;
        pressureTestHTML = createItem('Pressure Test Certificate', pressureTestText);
      }

      const hoseOnlyPriceText = hoseSubtotalInPennies > 0 ? `<span class="summary-item__price">£${(hoseSubtotalInPennies / 100).toFixed(2)}</span>` : '-';
      const assemblySubtotalText = totalPriceInPennies > 0 ? `<span class="summary-item__price">£${(totalPriceInPennies / 100).toFixed(2)}</span>` : '-';
      
      const mainContentHTML = `
        <div class="summary-details-main">
          ${createItem('Hose Type', hoseTitle)}
          ${createItem('Hose Bore', boreTitle)}
          ${createItem('Hose Length', lengthText)}
          ${fitting1HTML}
          ${fitting2HTML}
          ${pressureTestHTML}
          ${createItem('Assembly Subtotal', assemblySubtotalText)}
        </div>
      `;

      // remove from lines above
      // ${createItem('Delivery', 'FREE')}
      // ${createItem('Hose Only Price', hoseOnlyPriceText)}

      const staticInfoHeading = document.getElementById('hose-builder-static-info-heading')?.innerHTML || '';
      const staticInfoContent = document.getElementById('hose-builder-static-info-content')?.innerHTML || '';
      const staticInfoColorScheme = document.getElementById('hose-builder-static-info-scheme')?.dataset.scheme || 'none';
      let infoBoxHTML = '';
      if (staticInfoContent.trim() !== '') {
        const colorSchemeClass = staticInfoColorScheme !== 'none' ? `color-scheme color-scheme--${staticInfoColorScheme}` : '';
        infoBoxHTML = `
          <div class="summary-info-box ${colorSchemeClass}">
            ${staticInfoHeading ? `<h5>${staticInfoHeading}</h5>` : ''}
            <div class="rte">${staticInfoContent}</div>
          </div>
        `;
      }
      
      view.summary.details.innerHTML = mainContentHTML + infoBoxHTML;

      const finalPriceInPennies = totalPriceInPennies * quantity;
      view.summary.price.textContent = totalPriceInPennies > 0 ? `£${(finalPriceInPennies / 100).toFixed(2)}` : '-';
      view.summary.floatingPrice.textContent = totalPriceInPennies > 0 ? `£${(finalPriceInPennies / 100).toFixed(2)}` : '-';
      
      const isComplete = hose && bore && length > 0 && pressureTest;
      view.summary.button.disabled = !isComplete;
      view.summary.button.textContent = isComplete ? 'Add to Cart' : 'Complete Selection';
      view.summary.floatingBar.classList.toggle('is-hidden', !isComplete);
    },
    
    renderCollections: () => {
      const collections = state.allData.collections;
      const infoSvg = `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90"><defs><style>.cls-1{fill-rule:evenodd;}</style></defs><path class="cls-1" d="M45,0A45,45,0,1,1,0,45,45,45,0,0,1,45,0Zm0,35a5,5,0,0,0-5,5V71a5,5,0,0,0,10,0V40A5,5,0,0,0,45,35Zm0-21a7,7,0,1,0,7,7A7,7,0,0,0,45,14Z"/></svg>`;

      view.containers.collection.innerHTML = collections.map(collection => {
        const hasDescription = collection.description && collection.description.trim() !== '';
        let cardHTML = `<div class="builder-card" data-handle="${collection.handle}" data-type="collection">`;
        
        if (hasDescription) {
          cardHTML += `<button class="builder-card__info-btn" aria-label="More information" data-description='${collection.description}'>${infoSvg}</button>`;
        }
        
        cardHTML += `
            <div class="builder-card__content">
              <div class="builder-card__image-wrapper">
                ${collection.image_url ? `<img src="${collection.image_url}" alt="${collection.title}" loading="lazy">` : ''}
              </div>
              <h3>${collection.title}</h3>
            </div>
          </div>
        `;
        return cardHTML;
      }).join('');
    },
    renderHoses: () => {
      const selectedCollection = state.allData.collections.find(c => c.handle === state.selection.collectionHandle);
      if (!selectedCollection) return;
      view.containers.hose.innerHTML = selectedCollection.products.map(product => {
        const datasheetHTML = product.metafields.data_sheet ? `
          <a href="${product.metafields.data_sheet}" class="builder-card__datasheet-link" target="_blank" rel="noopener">
            <img src="https://cdn.shopify.com/s/files/1/0888/2149/8202/files/IF_Download_Datasheet.png?v=1728306240" class="builder-card__datasheet-image builder-card__datasheet-image--desktop" alt="Download Datasheet" loading="lazy">
            <img src="https://cdn.shopify.com/s/files/1/0888/2149/8202/files/datasheet-mobile.png?v=1759934937" class="builder-card__datasheet-image builder-card__datasheet-image--mobile" alt="Download Datasheet" loading="lazy">
          </a>
        ` : '';
        return `
          <div class="builder-card" data-handle="${product.handle}" data-type="hose">
            <div class="builder-card__content">
              <div class="builder-card__image-wrapper">
                <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
              </div>
              <h3>${product.title}</h3>
            </div>
            ${datasheetHTML}
          </div>
        `;
      }).join('');
    },
    renderBoreOptions: () => {
      const selectedHose = controller.getSelectedHose();
      if (!selectedHose) return;
      view.containers.bore.innerHTML = selectedHose.variants.map(variant => {
        const mmMatch = variant.title.match(/(\d+(\.\d+)?)\s*mm/);
        const mmValue = mmMatch ? parseFloat(mmMatch[1]) : 38;
        const size = 50 + mmValue * 0.5;
        const svgStyle = `width: ${size}px; height: ${size}px;`;
        const svgMarkup = `
          <svg style="${svgStyle}" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">
            <path d="M45,0A45,45,0,1,0,90,45,45,45,0,0,0,45,0Zm0,3A42,42,0,1,1,3,45,42,42,0,0,1,45,3Z" fill="#003e70"/>
            <path d="M19.54,57.82a1.49,1.49,0,0,0-.44,1.06V69.4a1.5,1.5,0,0,0,1.5,1.5H31.12a1.49,1.49,0,0,0,1.06-.44,1.42,1.42,0,0,0,.42-1,1.52,1.52,0,0,0-.42-1.09,1.56,1.56,0,0,0-1.08-.42l-6.87,0L67.89,24.23l0,6.87a1.56,1.56,0,0,0,.42,1.08,1.52,1.52,0,0,0,1.09.42,1.42,1.42,0,0,0,1-.42,1.49,1.49,0,0,0,.44-1.06V20.6a1.5,1.5,0,0,0-1.5-1.5H58.88a1.49,1.49,0,0,0-1.06.44,1.42,1.42,0,0,0-.42,1,1.52,1.52,0,0,0,.42,1.09,1.56,1.56,0,0,0,1.08.42l6.87,0L22.11,65.77l0-6.87a1.56,1.56,0,0,0-.42-1.08,1.52,1.52,0,0,0-1.09-.42A1.42,1.42,0,0,0,19.54,57.82Z" fill="#ff580b"/>
          </svg>
        `;
        return `
          <div class="builder-card" data-variant-id="${variant.id}" data-type="bore">
            <div class="builder-card__content">
              <div class="builder-card__image-wrapper">${svgMarkup}</div>
              <h3>${variant.title}</h3>
            </div>
          </div>
        `;
      }).join('');
    },
    renderLengthStep: () => {
      const selectedHose = controller.getSelectedHose();
      if (!selectedHose) return;
      const { min, max, start } = controller.getDefaultLengthData();
      const step = 0.01;
      view.containers.length.innerHTML = `
        <div class="length-input-wrapper">
          <div class="length-input-container">
            <input type="number" id="length-text-input" min="${min}" max="${max}" step="${step}">
            <span class="length-input-container__addon">m</span>
          </div>
          <div class="length-slider-container"><div id="length-slider"></div></div>
        </div>
      `;
      const slider = document.getElementById('length-slider');
      const textInput = document.getElementById('length-text-input');
      
      document.getElementById('length-step-description')?.classList.remove('is-hidden');

      noUiSlider.create(slider, {
        start: [start], connect: [true, false], step: step,
        tooltips: { to: function(value) { return `${parseFloat(value).toFixed(2)}m`; } },
        range: { 'min': min, 'max': max }
      });
      slider.noUiSlider.on('update', (values, handle) => {
        const value = parseFloat(values[handle]);
        if (document.activeElement !== textInput) textInput.value = value.toFixed(2);
        controller.handleLengthInput(value);
      });
      textInput.addEventListener('change', () => { slider.noUiSlider.set(textInput.value); });
    },
    renderFittings: (container, availableFittings) => {
      if (availableFittings.length === 0) {
        container.innerHTML = `<p class="builder-placeholder">No compatible fittings found for this hose and bore size.</p>`;
        return;
      }
      
      const infoSvg = `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90"><defs><style>.cls-1{fill-rule:evenodd;}</style></defs><path class="cls-1" d="M45,0A45,45,0,1,1,0,45,45,45,0,0,1,45,0Zm0,35a5,5,0,0,0-5,5V71a5,5,0,0,0,10,0V40A5,5,0,0,0,45,35Zm0-21a7,7,0,1,0,7,7A7,7,0,0,0,45,14Z"/></svg>`;

      const noFittingCard = `
        <div class="builder-card builder-card--no-option" data-variant-id="0" data-type="fitting" data-parent-step="${container.id}">
          <div class="builder-card__content">
            <h3>No End<br> Fitting</h3>
          </div>
        </div>
      `;
      
      const fittingCards = availableFittings.map(fitting => {
        const hasDescription = fitting.description && fitting.description.trim() !== '';
        let cardHTML = `<div class="builder-card" data-variant-id="${fitting.matchingVariant.id}" data-type="fitting" data-parent-step="${container.id}">`;
        
        if (hasDescription) {
          cardHTML += `<button class="builder-card__info-btn" aria-label="More information" data-description='${fitting.description}'>${infoSvg}</button>`;
        }
        
        cardHTML += `
            <div class="builder-card__content">
              <div class="builder-card__image-wrapper">
                <img src="${fitting.featured_image}" alt="${fitting.title}" loading="lazy">
              </div>
              <h3>${fitting.title}</h3>
              <!-- <p class="builder-card__price-add-on" data-price="${fitting.matchingVariant.price}">+ £${(fitting.matchingVariant.price / 100).toFixed(2)}</p> -->
            </div>
          </div>
        `;
        return cardHTML;
      }).join('');

      container.innerHTML = noFittingCard + fittingCards;
    },
    renderPressureTestStep: () => {
      const priceFormatted = (state.pressureTestPriceInPennies / 100).toFixed(2);
      view.containers.pressureTest.innerHTML = `
        <div class="builder-card builder-card--no-option" data-choice="no" data-type="pressure-test">
          <div class="builder-card__content">
            <h3>No</h3>
            <p class="builder-card__price-add-on" data-price="0">+ £0.00</p>
          </div>
        </div>
        <div class="builder-card builder-card--no-image" data-choice="yes" data-type="pressure-test">
          <div class="builder-card__content">
            <h3>Yes</h3>
            <p class="builder-card__price-add-on" data-price="${state.pressureTestPriceInPennies}">+ £${priceFormatted}</p>
          </div>
        </div>
      `;
    },
    showFittingLoader: (container) => { container.innerHTML = '<div class="loader"></div>'; },
    updateUI: () => {
      document.querySelectorAll('.builder-card.is-selected').forEach(el => el.classList.remove('is-selected'));
      
      if (state.selection.collectionHandle) document.querySelector(`[data-type="collection"][data-handle="${state.selection.collectionHandle}"]`)?.classList.add('is-selected');
      if (state.selection.hoseHandle) document.querySelector(`[data-type="hose"][data-handle="${state.selection.hoseHandle}"]`)?.classList.add('is-selected');
      if (state.selection.boreVariantId) document.querySelector(`[data-type="bore"][data-variant-id="${state.selection.boreVariantId}"]`)?.classList.add('is-selected');
      
      const fitting1Id = state.selection.fitting1VariantId || 0;
      const fitting1Card = document.querySelector(`#fitting1-container [data-variant-id="${fitting1Id}"]`);
      if (fitting1Card) fitting1Card.classList.add('is-selected');
      
      const fitting2Id = state.selection.fitting2VariantId || 0;
      const fitting2Card = document.querySelector(`#fitting2-container [data-variant-id="${fitting2Id}"]`);
      if (fitting2Card) fitting2Card.classList.add('is-selected');

      if (state.selection.pressureTest) document.querySelector(`[data-type="pressure-test"][data-choice="${state.selection.pressureTest}"]`)?.classList.add('is-selected');

      view.steps.step2.classList.toggle('is-disabled', !state.selection.collectionHandle);
      view.steps.step3.classList.toggle('is-disabled', !state.selection.hoseHandle);
      view.steps.step4.classList.toggle('is-disabled', !state.selection.boreVariantId);
      const showFittings = state.selection.boreVariantId && state.selection.length > 0;
      view.steps.step5.classList.toggle('is-disabled', !showFittings);
      view.steps.step6.classList.toggle('is-disabled', !showFittings);
      view.steps.step7.classList.toggle('is-disabled', !showFittings);
      view.renderSummary();
    }
  };

  const controller = {
    init: () => {
      view.renderCollections();
      controller.addEventListeners();
      controller.setupModal(view.modals.guide, '.js-open-guide-modal');
      controller.setupModal(view.modals.info, '.builder-card__info-btn');
      view.renderSummary(); 
    },
    setupModal: (modal, triggerSelector) => {
      if (!modal) return;
      modal.style.display = '';
      
      const closeButton = modal.querySelector('.hb-modal-close');
      const htmlEl = document.documentElement;
      const bodyEl = document.body;
      let scrollY;

      const openModal = (content) => {
        scrollY = window.scrollY;
        
        if (content && view.modals.infoContent) {
          view.modals.infoContent.innerHTML = content;
        }

        modal.classList.remove('is-hidden');
        bodyEl.style.top = `-${scrollY}px`;
        htmlEl.classList.add('hb-modal-is-open');
        bodyEl.classList.add('hb-modal-is-open');
        document.addEventListener('keydown', handleEscKey);
      };

      const closeModal = () => {
        htmlEl.classList.remove('hb-modal-is-open');
        bodyEl.classList.remove('hb-modal-is-open');
        bodyEl.style.top = '';
        modal.classList.add('is-hidden');
        window.scrollTo(0, scrollY);
        document.removeEventListener('keydown', handleEscKey);
      };

      const handleEscKey = (event) => { if (event.key === 'Escape') closeModal(); };

      document.addEventListener('click', (e) => {
        const trigger = e.target.closest(triggerSelector);
        if (trigger) {
          e.preventDefault();
          e.stopPropagation();
          const description = trigger.dataset.description || '';
          openModal(description);
        }
      });

      if (closeButton) closeButton.addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    },

    getSummaryData: () => {
      const hose = controller.getSelectedHose();
      const bore = controller.getSelectedBoreVariant();
      const length = state.selection.length;
      const fitting1 = controller.getSelectedFittingVariant(state.selection.fitting1VariantId);
      const fitting2 = controller.getSelectedFittingVariant(state.selection.fitting2VariantId);
      const pressureTest = state.selection.pressureTest;

      const hosePricePerMeterInPennies = bore ? bore.price : 0;
      const fitting1PriceInPennies = fitting1 ? fitting1.price : 0;
      const fitting2PriceInPennies = fitting2 ? fitting2.price : 0;
      const pressureTestPriceInPennies = pressureTest === 'yes' ? state.pressureTestPriceInPennies : 0;
      
      const hoseSubtotalInPennies = length > 0 ? Math.round(hosePricePerMeterInPennies * length) : 0;
      
      const totalPriceInPennies = hoseSubtotalInPennies + fitting1PriceInPennies + fitting2PriceInPennies + pressureTestPriceInPennies;

      return { hose, bore, length, fitting1, fitting2, pressureTest, hoseSubtotalInPennies, totalPriceInPennies };
    },
    handleAddToCart: async (event) => {
      event.preventDefault();
      const button = event.target;
      view.summary.cartOverlay.style.display = '';
      view.summary.cartOverlay.classList.remove('is-hidden');
      button.disabled = true;

      const { hose, bore, length, fitting1, fitting2, pressureTest, totalPriceInPennies } = controller.getSummaryData();
      const quantity = parseInt(view.summary.quantityInput.value) || 1;

      if (!hose || !bore || !length || !pressureTest) {
        alert('An error occurred. Please refresh and try again.');
        view.summary.cartOverlay.classList.add('is-hidden');
        button.disabled = false;
        return;
      }
      const feeProductId = '10374892290394';

      // --- START OF CHANGES ---
      const allProperties = {
        'Hose Type': hose.title,
        'Hose SKU': bore.sku || '-', // Added Hose SKU
        'Bore Size': bore.title,
        'Hose Length': `${length.toFixed(2)}m`,
        
        'Hose End Fitting 1': fitting1 ? fitting1.parent.title : 'None',
        'Fitting 1 SKU': fitting1 ? (fitting1.sku || '-') : '-', // Added Fitting 1 SKU
        
        'Hose End Fitting 2': fitting2 ? fitting2.parent.title : 'None',
        'Fitting 2 SKU': fitting2 ? (fitting2.sku || '-') : '-', // Added Fitting 2 SKU
        
        'Pressure Test Certificate': pressureTest === 'yes' ? 'Yes' : 'No'
      };
      // --- END OF CHANGES ---
      
      const priceForApp = (totalPriceInPennies / 100).toFixed(2);

      try {
        let successfulAdds = 0;
        for (let i = 0; i < quantity; i++) {
          const result = await controller.addFeeItem(feeProductId, priceForApp, allProperties);
          if (result.status === 'success') {
            successfulAdds++;
          } else {
            throw new Error(`One or more items failed to add. Message: ${result.message}`);
          }
        }
        window.location.href = '/cart';
      
      } catch (error) {
        console.error('Add to Cart Error:', error);
        alert(`There was an error adding items to your cart: ${error.message}`);
        view.summary.cartOverlay.classList.add('is-hidden');
        button.disabled = false;
      }
    },
    addEventListeners: () => {
      const builder = document.querySelector('.hose-builder');
      builder.addEventListener('click', (e) => {
        if (e.target.closest('.builder-card__info-btn') || e.target.closest('.builder-card__datasheet-link')) {
          return;
        }

        const card = e.target.closest('.builder-card');
        if (card) {
          const { handle, type, variantId, parentStep, choice } = card.dataset;
          if (type === 'collection') controller.handleCollectionSelect(handle);
          else if (type === 'hose') controller.handleHoseSelect(handle);
          else if (type === 'bore') controller.handleBoreSelect(parseInt(variantId));
          else if (type === 'fitting') controller.handleFittingSelect(parseInt(variantId), parentStep);
          else if (type === 'pressure-test') controller.handlePressureTestSelect(choice);
        }
      });

      view.summary.button.addEventListener('click', controller.handleAddToCart);

      const qtyInput = view.summary.quantityInput;
      const minusBtn = document.querySelector('.js-qty-minus');
      const plusBtn = document.querySelector('.js-qty-plus');

      if (qtyInput && minusBtn && plusBtn) {
        minusBtn.addEventListener('click', () => {
          let value = parseInt(qtyInput.value) || 1;
          value = Math.max(1, value - 1);
          qtyInput.value = value;
          view.renderSummary();
        });

        plusBtn.addEventListener('click', () => {
          let value = parseInt(qtyInput.value) || 1;
          qtyInput.value = value + 1;
          view.renderSummary();
        });

        qtyInput.addEventListener('input', view.renderSummary);
        qtyInput.addEventListener('change', view.renderSummary);
      }
      
      view.summary.floatingButton.addEventListener('click', () => {
        view.summary.container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    },
    scrollToNextStep: (element) => {
      setTimeout(() => {
        if (!element) return;
        const stickyHeader = document.querySelector('.cc-header--sticky');
        const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
        const extraPadding = 30;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerHeight - extraPadding;
    
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }, 100);
    },
    getSelectedHose: () => {
      const coll = state.allData.collections.find(c => c.handle === state.selection.collectionHandle);
      return coll?.products.find(p => p.handle === state.selection.hoseHandle);
    },
    getSelectedBoreVariant: () => controller.getSelectedHose()?.variants.find(v => v.id === state.selection.boreVariantId),
    getSelectedFittingVariant: (variantId) => {
      if (!variantId) return null;
      for (const handle in state.loadedFittings) {
        const fitting = state.loadedFittings[handle];
        const variant = fitting.variants.find(v => v.id === variantId);
        if (variant) return { ...variant, parent: fitting };
      }
      return null;
    },
    fetchFittingData: async (handle) => {
      if (state.loadedFittings[handle]) return state.loadedFittings[handle];
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) throw new Error('Product not found');
        const productData = await response.json();
        state.loadedFittings[handle] = productData;
        return productData;
      } catch (error) { console.error(`Failed to fetch fitting ${handle}:`, error); return null; }
    },
    loadAndRenderFittings: async () => {
      view.showFittingLoader(view.containers.fitting1);
      view.showFittingLoader(view.containers.fitting2);
      view.renderPressureTestStep();
      const selectedHose = controller.getSelectedHose();
      const selectedBoreVariant = controller.getSelectedBoreVariant();
      if (!selectedHose || !selectedBoreVariant) return;
      
      const compatibleHandles = selectedHose.metafields.compatible_fittings;
      const boreTitle = selectedBoreVariant.title;
      const fittingPromises = compatibleHandles.map(handle => controller.fetchFittingData(handle));
      const allFittings = (await Promise.all(fittingPromises)).filter(Boolean);
      
      const availableFittings = allFittings.map(fitting => {
        const matchingVariant = fitting.variants.find(v => v.title === boreTitle);
        return matchingVariant ? { ...fitting, matchingVariant } : null;
      }).filter(Boolean);

      if (availableFittings.length === 0) {
        state.selection.fitting1VariantId = null;
        state.selection.fitting2VariantId = null;
      }

      view.renderFittings(view.containers.fitting1, availableFittings);
      view.renderFittings(view.containers.fitting2, availableFittings);
      view.updateUI();
    },
    handleCollectionSelect: (handle) => {
      Object.assign(state.selection, { collectionHandle: handle, hoseHandle: null, boreVariantId: null, length: null, fitting1VariantId: null, fitting2VariantId: null, pressureTest: null });
      view.renderHoses();
      ['bore', 'length', 'fitting1', 'fitting2', 'pressureTest'].forEach(c => view.containers[c].innerHTML = `<p class="builder-placeholder">Please complete previous steps.</p>`);
      document.getElementById('length-step-description')?.classList.add('is-hidden');
      view.updateUI();
      controller.scrollToNextStep(view.steps.step2);
    },
    handleHoseSelect: (handle) => {
      Object.assign(state.selection, { hoseHandle: handle, boreVariantId: null, length: null, fitting1VariantId: null, fitting2VariantId: null, pressureTest: null });
      view.renderBoreOptions();
      ['length', 'fitting1', 'fitting2', 'pressureTest'].forEach(c => view.containers[c].innerHTML = `<p class="builder-placeholder">Please complete previous steps.</p>`);
      document.getElementById('length-step-description')?.classList.add('is-hidden');
      view.updateUI();
      controller.scrollToNextStep(view.steps.step3);
    },
    handleBoreSelect: (variantId) => {
      Object.assign(state.selection, { boreVariantId: variantId, fitting1VariantId: null, fitting2VariantId: null, pressureTest: 'no' });
      const defaultLengthData = controller.getDefaultLengthData();
      state.selection.length = defaultLengthData.start;
      view.renderLengthStep();
      controller.loadAndRenderFittings();
      view.updateUI();
      controller.scrollToNextStep(view.steps.step4);
    },
    handleLengthInput: (value) => {
      const val = parseFloat(value);
      const wasNullOrZero = !state.selection.length;
      state.selection.length = val > 0 ? val : null;
      if (state.selection.length && wasNullOrZero) {
        controller.loadAndRenderFittings();
      } else if (!state.selection.length) {
        ['fitting1', 'fitting2', 'pressureTest'].forEach(c => view.containers[c].innerHTML = `<p class="builder-placeholder">Please enter a hose length above.</p>`);
      }
      view.updateUI();
    },
    handleFittingSelect: (variantId, parentStep) => {
      const newVariantId = variantId === 0 ? null : variantId;
      if (parentStep === 'fitting1-container') {
        state.selection.fitting1VariantId = newVariantId;
      } else if (parentStep === 'fitting2-container') {
        state.selection.fitting2VariantId = newVariantId;
      }
      view.updateUI();
    },
    handlePressureTestSelect: (choice) => {
      state.selection.pressureTest = choice;
      view.updateUI();
      controller.scrollToNextStep(view.summary.container);
    },
    addFeeItem: async (feeProductId, price, properties) => {
      const addifyBaseUrl = "https://name-your-price.addify-app.com";
      const shopDomain = window.Shopify?.shop || 'integraflex.myshopify.com';
      const params = new URLSearchParams({
        productId: feeProductId,
        shopName: shopDomain,
        productFieldValue: price,
        variantSelectedOption: 'Custom Hose Assembly',
      });
      try {
        const addifyResponse = await fetch(`${addifyBaseUrl}/api/create-variant?${params.toString()}`);
        const addifyData = await addifyResponse.json();
        if (!addifyData || !addifyData.variant_id) {
          console.error('Addify App Error:', addifyData);
          return { status: 'error', message: addifyData.message || 'The pricing app could not create a fee variant.' };
        }
        return await controller.addItemToCart(addifyData.variant_id, 1, properties);
      } catch (error) {
        console.error('Network error communicating with Addify App:', error);
        return { status: 'error', message: 'Error communicating with the pricing app.' };
      }
    },
    addItemToCart: (variantId, quantity, properties = {}) => {
      return new Promise((resolve) => {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity, properties: properties }] })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status >= 400 || data.description) {
            resolve({ status: 'error', message: data.description || 'Unknown error adding item.' });
          } else {
            resolve({ status: 'success', data: data });
          }
        })
        .catch(error => resolve({ status: 'error', message: 'Network error adding item.' }));
      });
    },
    getDefaultLengthData: () => {
        const selectedHose = controller.getSelectedHose();
        const min = 0.50;
        const max = selectedHose?.metafields.max_length_m || 100;
        const start = (max - min) / 2 + min;
        return { min, max, start };
    }
  };

  controller.init();
});